import { styled } from "@mui/material";

interface Page {
    center?: boolean;
}

export const Styled = {
    Page: styled("div", { shouldForwardProp: prop => prop !== "center" })<Page>`
        display: flex;
        flex-direction: column;
        justify-content: ${props => (props.center ? "center" : "initial")};
        align-items: ${props => (props.center ? "center" : "initial")};
        height: 100%;
        width: 100%;
        padding: 10px 0px;
        overflow-y: auto;
    `,
};
